import { Component, Input, Inject, NgModuleRef, OnInit } from '@angular/core';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { IModalsService, IMODALS_SERVICE } from '@platform500services/p500-ui-kit';
import { Auth2FAModal } from '../../modals/2fa/2fa.modal';
import { AuthServiceInterface } from '../../services/auth/auth-service.interface';
import { IConfigurationService } from '../../services/configuration/configuration-service.interface';
import { EventsServiceInterface } from '../../services/events/events.interface';
import { IUnsecuredService } from '../../services/unsecured/unsecured-service.interface';
import { DestroySubscribers } from '../../decorators/destroy-subscribers.decorator';
import { GTD_BROADCAST_EVENTS } from '../../services/events/broadcast-event.interface';
import { ISettingsServiceInterface } from '../../services/settings/settings-service.interface';

@Component({
  selector: 'gtd-profile-menu',
  templateUrl: './profile-menu.component.html',
})
@DestroySubscribers()
export class ProfileMenuComponent implements OnInit {
  @Input() cssClass = '';
  public userID: number;
  public unsecuredModeControl = new UntypedFormControl(false);
  public controlLink: string;
  public affManagerId: number;

  private settingsKey = 'help-menu';
  private supportChatSetting = 'support-chat';
  private subscribers: any = {};

  public supportChatControl = new FormControl<boolean>(true, { nonNullable: true });

  constructor(
    @Inject('AuthServiceInterface') public authService: AuthServiceInterface,
    private router: Router,
    @Inject('IUnsecuredService') public unsecuredService: IUnsecuredService,
    @Inject(IMODALS_SERVICE) private modalsService: IModalsService,
    private moduleRef: NgModuleRef<any>,
    @Inject('EventsServiceInterface') private eventsService: EventsServiceInterface,
    @Inject('IConfigurationService') configurationService: IConfigurationService,
    @Inject('ISettingsService') private settingsService: ISettingsServiceInterface
  ) {
    const user = this.authService.userData();
    this.userID = user.id;
    this.affManagerId = user.affiliate_manager;

    this.unsecuredService.getUnsecuredStatus().subscribe((status) => {
      this.unsecuredModeControl.setValue(status.isUnsecured, { emitEvent: false });
    });
    this.unsecuredModeControl.valueChanges.subscribe((value) => {
      if (value) {
        this.modalsService.open(Auth2FAModal, {}, this.moduleRef);
        this.unsecuredModeControl.setValue(false);
      } else {
        this.unsecuredService.leave().subscribe((response) => {
          if (response.data && response.data.user) {
            this.unsecuredService.setUnsecuredStatus(false);
          }
        });
      }
    });
    this.controlLink = configurationService.data().controlLink;
  }

  ngOnInit() {
    this.subscribers.loadSetting = this.settingsService.loadSettings().subscribe((settings) => {
      this.settingsService.settings[this.settingsKey] = settings[this.settingsKey] ?? {};
      this.setSupportChatValue();

      this.subscribers.supportChatControl = this.supportChatControl.valueChanges.subscribe((value) => {
        this.settingsService.saveSettingsByKey(this.settingsKey, this.supportChatSetting, value);
        this.eventsService.broadcast(GTD_BROADCAST_EVENTS.FRONT_CHAT_SHOW, value);
      });
    });
  }

  private setSupportChatValue(): void {
    const settings = this.settingsService.settings;
    if (settings && settings[this.settingsKey]) {
      const supportChatValue = settings[this.settingsKey][this.supportChatSetting];
      if (supportChatValue !== null && supportChatValue !== undefined) {
        this.supportChatControl.setValue(supportChatValue);
      }
    }
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/auth/signin'], { queryParams: { logout: true } });
  }
}
